import { isSessionExpiredAuthError } from 'providers/auth0/isSessionExpiredAuthError';

import Logger from 'utils/logger';

import { createAppAsyncThunk } from '../createAppAsyncThunk';
import { KEYS } from './keys';
import { processUserInfoArgs } from './types';
import { getAndSetUserLevelAndData, updateAuthToken } from './utils';

// Transient errors where the SDK may retry; do not treat as fatal auth failure.
const TRANSIENT_ERRORS = ['Timeout'];

export const processUserInfo = createAppAsyncThunk(
  KEYS.THUNK_NAME,
  async ({ auth0User, getAccessTokenSilently }: processUserInfoArgs, { dispatch, rejectWithValue }) => {
    try {
      const accessToken = await getAccessTokenSilently();
      updateAuthToken(accessToken, dispatch);

      return getAndSetUserLevelAndData(accessToken, auth0User, dispatch);
    } catch (error: any) {
      const errorMessage = error?.error || error?.message || '';

      if (!window.s4cConfig.isLegacyProduction && isSessionExpiredAuthError(error)) {
        Logger.warn(`Session expired auth error: ${errorMessage}`);
        return rejectWithValue(errorMessage);
      }

      if (!window.s4cConfig.isLegacyProduction) {
        const isTransient = TRANSIENT_ERRORS.some((e) => String(error?.message || '').includes(e));
        if (isTransient) {
          Logger.warn(`Transient auth issue: ${error?.message || ''}`);
          return undefined;
        }
      }

      Logger.error(`Authentication error: ${errorMessage}`);
      return rejectWithValue(errorMessage);
    }
  },
);
